import {
  Box,
  Button,
  Flex,
  IconButton,
  Popover,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tooltip,
  VisuallyHidden,
  useBoolean,
} from '@chakra-ui/react';
import { ReactComponent as CheckIcon } from 'assets/icons/check_circle_outline.svg';
import { ReactComponent as CircleIcon } from 'assets/icons/shapes/circle.svg';
import { ReactComponent as SquareIcon } from 'assets/icons/shapes/square.svg';
import { useTranslation } from 'react-i18next';

import { CheckboxOptions } from '../extensions/Checkbox';

interface InsertCheckboxButtonProps {
  onClick: (type: CheckboxOptions['checkboxType']) => void;
}

export const InsertCheckboxButton = ({ onClick }: InsertCheckboxButtonProps) => {
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'tableToolbar.checkbox', useSuspense: false });
  const label = t('label');

  const [isOpen, setIsOpen] = useBoolean(false);

  const handleClose = () => setIsOpen.off();

  return (
    <Popover isOpen={isOpen} placement='bottom-start' onClose={handleClose} closeOnBlur closeOnEsc isLazy>
      <Tooltip hasArrow placement='bottom' label={label} bg='black'>
        <Box>
          <PopoverTrigger>
            <IconButton
              aria-label={label}
              icon={<CheckIcon color='var(--vg-colors-font-500)' />}
              size='sm'
              variant={'ghost-with-active'}
              onClick={setIsOpen.toggle}
              isActive={isOpen}
            />
          </PopoverTrigger>
        </Box>
      </Tooltip>
      <PopoverContent w='fit-content' minW='92px'>
        <VisuallyHidden>
          <PopoverHeader>{label}</PopoverHeader>
        </VisuallyHidden>
        <Flex flexDir='column' p='8px' gap='4px'>
          <Button
            aria-label={t('ariaLabelCircle')}
            onClick={() => {
              onClick('circle');
              handleClose();
            }}
            variant='icon-btn-toolbar'
            size='sm'
            leftIcon={<CircleIcon />}
            w='100%'
            p='4px'
            justifyContent='unset'
            color='var(--vg-colors-font-500)'
          >
            {t('circle')}
          </Button>

          <Button
            aria-label={t('ariaLabelSquare')}
            onClick={() => {
              onClick('square');
              handleClose();
            }}
            variant='icon-btn-toolbar'
            size='sm'
            leftIcon={<SquareIcon />}
            w='100%'
            p='4px'
            justifyContent='unset'
            color='var(--vg-colors-font-500)'
          >
            {t('square')}
          </Button>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
